import { useCallback, useState } from "react";
import { InputMode, ResponseMode } from "./types";

const STORAGE_KEY = "fibiModes";

export function useFibiModes() {
  const [modes, setModes] = useState<{
    responseMode: ResponseMode;
    inputMode: InputMode;
  }>(() => {
    try {
      const json = localStorage.getItem(STORAGE_KEY);
      if (json) {
        const parsed = JSON.parse(json);
        return {
          responseMode: parsed.responseMode as ResponseMode,
          inputMode: parsed.inputMode as InputMode,
        };
      }
    } catch {
      /* ignore */
    }
    return {
      responseMode: "text-voice",
      inputMode: "voice-text",
    };
  });

  const setResponseMode = useCallback((responseMode: ResponseMode) => {
    setModes((prev) => {
      const next = { ...prev, responseMode };
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch {
        /* ignore write errors */
      }
      return next;
    });
  }, []);

  const setInputMode = useCallback((inputMode: InputMode) => {
    setModes((prev) => {
      const next = { ...prev, inputMode };
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      } catch {
        /* ignore write errors */
      }
      return next;
    });
  }, []);

  return {
    responseMode: modes.responseMode,
    inputMode: modes.inputMode,
    setResponseMode,
    setInputMode,
  };
}
